module.exports = __webpack_public_path__ + "static/media/hm.fc838ac0.svg";